import { Heading, Link, Text } from '@apollo/orbit';
import classnames from 'classnames';
import React, { ReactElement, cloneElement } from 'react';

export function EmptyLayout({
  icon,
  title,
  body,
  learnMoreHref,
  className,
}: {
  icon?: ReactElement;
  title?: string;
  body: string | ReactElement;
  learnMoreHref?: string;
  className?: string;
}) {
  return (
    <div
      className={classnames(
        className,
        'flex h-full flex-col items-center justify-center gap-4 text-center',
      )}
    >
      {icon &&
        cloneElement(icon, {
          className: classnames(icon?.props.className, 'text-icon-primary'),
        })}
      {title && <Heading as="h3">{title}</Heading>}
      <Text className="max-w-2xl">
        {body}
        {learnMoreHref ? (
          <>
            {' '}
            <Link isExternal to={learnMoreHref} className="whitespace-nowrap">
              Learn more
            </Link>
          </>
        ) : null}
      </Text>
    </div>
  );
}
